import { lowerCase as e } from "../../lower-case/dist.es2015/index.js";
var r = [/([a-z0-9])([A-Z])/g, /([A-Z])([A-Z][a-z])/g],
  i = /[^A-Z0-9]+/gi;
function o(o, n) {
  void 0 === n && (n = {});
  for (var a = n.splitRegexp, c = n.stripRegexp, p = n.transform, s = void 0 === p ? e : p, x = n.delimiter, d = void 0 === x ? " " : x, f = t(t(o, void 0 === a ? r : a, "$1\x00$2"), void 0 === c ? i : c, "\x00"), l = 0, g = f.length; "\x00" === f.charAt(l);) l++;
  for (; "\x00" === f.charAt(g - 1);) g--;
  return f.slice(l, g).split("\x00").map(s).join(d);
}
function t(e, r, i) {
  return r instanceof RegExp ? e.replace(r, i) : r.reduce(function (e, r) {
    return e.replace(r, i);
  }, e);
}
export { o as noCase };